import {
  queryQuotaRecordListByPage,
  setChildBusinessQuota,
  updateChildBusinessQuotaRecord
} from '@/api/sys.quota'

export default {
  namespaced: true,
  actions: {

    queryQuotaRecordListByPage ({
      dispatch
    }, {
      vm,
      data
    }) {
      return queryQuotaRecordListByPage(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    setChildBusinessQuota ({
      dispatch
    }, {
      vm,
      data
    }) {
      return setChildBusinessQuota(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    updateChildBusinessQuotaRecord ({
      dispatch
    }, {
      vm,
      data
    }) {
      return updateChildBusinessQuotaRecord(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    }
  }
}
